import FrontEndApi from '../../../../Common/Globals/Scripts/FrontEndApi';

async function exportRates(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval) {
    return await FrontEndApi.getExportRateCardsAsCsv(
        rateCardOwners,
        rateActivities,
        rateChargeTypes,
        rateCardTypes,
        customers,
        suppliers,
        soldToParties,
        rateProducts,
        fromRateZones,
        toRateZones,
        effectiveDateInterval,
        FrontEndApi.exportType.Csv);
}

async function loadSearchCriteriaLookups() {
    return await FrontEndApi.getExistingRateCardCriteria();
}

async function loadViewableRateCards(rateCardOwners, rateActivities, rateChargeTypes, rateCardTypes, customers, suppliers, soldToParties, rateProducts, fromRateZones, toRateZones, effectiveDateInterval) {
    return await FrontEndApi.getViewableRateCardsByCriteria(
        rateCardOwners,
        rateActivities,
        rateChargeTypes,
        rateCardTypes,
        customers,
        suppliers,
        soldToParties,
        rateProducts,
        fromRateZones,
        toRateZones,
        effectiveDateInterval);
}

async function deleteRateCards(rateCardIds) {
    await FrontEndApi.deleteRateCards(rateCardIds);
}

async function loadRateCardAuthorisations(commandsThatMayBeExecuted) {
    return await FrontEndApi.getCommandAuthorisations(commandsThatMayBeExecuted);
}

export default { exportRates, loadSearchCriteriaLookups, loadViewableRateCards, deleteRateCards, loadRateCardAuthorisations }
